export const AllCountryCodes = {
  // North America
  "+1": {
    name: "United States / Canada",
    pattern: "+1 (###) ###-####",
    maxLength: 10,
    flag: "🇺🇸🇨🇦",
  },

  // Europe
  "+7": {
    name: "Russia / Kazakhstan",
    pattern: "+7 ### ###-##-##",
    maxLength: 10,
    flag: "🇷🇺🇰🇿",
  },
  "+20": {
    name: "Egypt",
    pattern: "+20 ## #### ####",
    maxLength: 10,
    flag: "🇪🇬",
  },
  "+27": {
    name: "South Africa",
    pattern: "+27 ## ### ####",
    maxLength: 9,
    flag: "🇿🇦",
  },
  "+30": {
    name: "Greece",
    pattern: "+30 ### ### ####",
    maxLength: 10,
    flag: "🇬🇷",
  },
  "+31": {
    name: "Netherlands",
    pattern: "+31 # #### ####",
    maxLength: 9,
    flag: "🇳🇱",
  },
  "+32": {
    name: "Belgium",
    pattern: "+32 ### ## ## ##",
    maxLength: 9,
    flag: "🇧🇪",
  },
  "+33": {
    name: "France",
    pattern: "+33 # ## ## ## ##",
    maxLength: 9,
    flag: "🇫🇷",
  },
  "+34": {
    name: "Spain",
    pattern: "+34 ### ### ###",
    maxLength: 9,
    flag: "🇪🇸",
  },
  "+36": {
    name: "Hungary",
    pattern: "+36 ## ### ####",
    maxLength: 9,
    flag: "🇭🇺",
  },
  "+39": {
    name: "Italy",
    pattern: "+39 ### ### ####",
    maxLength: 10,
    flag: "🇮🇹",
  },
  "+40": {
    name: "Romania",
    pattern: "+40 ### ### ###",
    maxLength: 9,
    flag: "🇷🇴",
  },
  "+41": {
    name: "Switzerland",
    pattern: "+41 ## ### ## ##",
    maxLength: 9,
    flag: "🇨🇭",
  },
  "+43": {
    name: "Austria",
    pattern: "+43 ### ######",
    maxLength: 11,
    flag: "🇦🇹",
  },
  "+44": {
    name: "United Kingdom",
    pattern: "+44 #### ######",
    maxLength: 10,
    flag: "🇬🇧",
  },
  "+45": {
    name: "Denmark",
    pattern: "+45 ## ## ## ##",
    maxLength: 8,
    flag: "🇩🇰",
  },
  "+46": {
    name: "Sweden",
    pattern: "+46 ### ### ###",
    maxLength: 9,
    flag: "🇸🇪",
  },
  "+47": {
    name: "Norway",
    pattern: "+47 ### ## ###",
    maxLength: 8,
    flag: "🇳🇴",
  },
  "+48": {
    name: "Poland",
    pattern: "+48 ### ### ###",
    maxLength: 9,
    flag: "🇵🇱",
  },
  "+49": {
    name: "Germany",
    pattern: "+49 ### ########",
    maxLength: 11,
    flag: "🇩🇪",
  },
  "+51": { name: "Peru", pattern: "+51 ### ### ###", maxLength: 9, flag: "🇵🇪" },
  "+52": {
    name: "Mexico",
    pattern: "+52 ## #### ####",
    maxLength: 10,
    flag: "🇲🇽",
  },
  "+53": { name: "Cuba", pattern: "+53 # ### ####", maxLength: 8, flag: "🇨🇺" },
  "+54": {
    name: "Argentina",
    pattern: "+54 ## #### ####",
    maxLength: 10,
    flag: "🇦🇷",
  },
  "+55": {
    name: "Brazil",
    pattern: "+55 ## #####-####",
    maxLength: 11,
    flag: "🇧🇷",
  },
  "+56": {
    name: "Chile",
    pattern: "+56 # #### ####",
    maxLength: 9,
    flag: "🇨🇱",
  },
  "+57": {
    name: "Colombia",
    pattern: "+57 ### ### ####",
    maxLength: 10,
    flag: "🇨🇴",
  },
  "+58": {
    name: "Venezuela",
    pattern: "+58 ### ### ####",
    maxLength: 10,
    flag: "🇻🇪",
  },
  "+60": {
    name: "Malaysia",
    pattern: "+60 ##-### ####",
    maxLength: 9,
    flag: "🇲🇾",
  },
  "+61": {
    name: "Australia",
    pattern: "+61 # #### ####",
    maxLength: 9,
    flag: "🇦🇺",
  },
  "+62": {
    name: "Indonesia",
    pattern: "+62 ###-###-####",
    maxLength: 11,
    flag: "🇮🇩",
  },
  "+63": {
    name: "Philippines",
    pattern: "+63 ### ### ####",
    maxLength: 10,
    flag: "🇵🇭",
  },
  "+64": {
    name: "New Zealand",
    pattern: "+64 ## ### ####",
    maxLength: 9,
    flag: "🇳🇿",
  },
  "+65": {
    name: "Singapore",
    pattern: "+65 #### ####",
    maxLength: 8,
    flag: "🇸🇬",
  },
  "+66": {
    name: "Thailand",
    pattern: "+66 ## ### ####",
    maxLength: 9,
    flag: "🇹🇭",
  },
  "+81": {
    name: "Japan",
    pattern: "+81 ##-####-####",
    maxLength: 10,
    flag: "🇯🇵",
  },
  "+82": {
    name: "South Korea",
    pattern: "+82 ##-####-####",
    maxLength: 10,
    flag: "🇰🇷",
  },
  "+84": {
    name: "Vietnam",
    pattern: "+84 ### ### ###",
    maxLength: 9,
    flag: "🇻🇳",
  },
  "+86": {
    name: "China",
    pattern: "+86 ### #### ####",
    maxLength: 11,
    flag: "🇨🇳",
  },
  "+90": {
    name: "Turkey",
    pattern: "+90 ### ### ## ##",
    maxLength: 10,
    flag: "🇹🇷",
  },
  "+91": {
    name: "India",
    pattern: "+91 ##### #####",
    maxLength: 10,
    flag: "🇮🇳",
  },
  "+92": {
    name: "Pakistan",
    pattern: "+92 ### ### ####",
    maxLength: 10,
    flag: "🇵🇰",
  },
  "+93": {
    name: "Afghanistan",
    pattern: "+93 ## ### ####",
    maxLength: 9,
    flag: "🇦🇫",
  },
  "+94": {
    name: "Sri Lanka",
    pattern: "+94 ## ### ####",
    maxLength: 9,
    flag: "🇱🇰",
  },
  "+95": {
    name: "Myanmar",
    pattern: "+95 ## ### ####",
    maxLength: 9,
    flag: "🇲🇲",
  },
  "+98": {
    name: "Iran",
    pattern: "+98 ### ### ####",
    maxLength: 10,
    flag: "🇮🇷",
  },
  "+212": {
    name: "Morocco",
    pattern: "+212 ###-######",
    maxLength: 9,
    flag: "🇲🇦",
  },
  "+213": {
    name: "Algeria",
    pattern: "+213 ### ## ## ##",
    maxLength: 9,
    flag: "🇩🇿",
  },
  "+216": {
    name: "Tunisia",
    pattern: "+216 ## ### ###",
    maxLength: 8,
    flag: "🇹🇳",
  },
  "+218": {
    name: "Libya",
    pattern: "+218 ##-#######",
    maxLength: 9,
    flag: "🇱🇾",
  },
  "+220": {
    name: "Gambia",
    pattern: "+220 ### ####",
    maxLength: 7,
    flag: "🇬🇲",
  },
  "+221": {
    name: "Senegal",
    pattern: "+221 ## ### ## ##",
    maxLength: 9,
    flag: "🇸🇳",
  },
  "+222": {
    name: "Mauritania",
    pattern: "+222 ## ## ## ##",
    maxLength: 8,
    flag: "🇲🇷",
  },
  "+223": {
    name: "Mali",
    pattern: "+223 ## ## ## ##",
    maxLength: 8,
    flag: "🇲🇱",
  },
  "+224": {
    name: "Guinea",
    pattern: "+224 ### ## ## ##",
    maxLength: 9,
    flag: "🇬🇳",
  },
  "+225": {
    name: "Ivory Coast",
    pattern: "+225 ## ## ## ##",
    maxLength: 8,
    flag: "🇨🇮",
  },
  "+226": {
    name: "Burkina Faso",
    pattern: "+226 ## ## ## ##",
    maxLength: 8,
    flag: "🇧🇫",
  },
  "+227": {
    name: "Niger",
    pattern: "+227 ## ## ## ##",
    maxLength: 8,
    flag: "🇳🇪",
  },
  "+228": {
    name: "Togo",
    pattern: "+228 ## ## ## ##",
    maxLength: 8,
    flag: "🇹🇬",
  },
  "+229": {
    name: "Benin",
    pattern: "+229 ## ## ## ##",
    maxLength: 8,
    flag: "🇧🇯",
  },
  "+230": {
    name: "Mauritius",
    pattern: "+230 #### ####",
    maxLength: 8,
    flag: "🇲🇺",
  },
  "+231": {
    name: "Liberia",
    pattern: "+231 ## ### ####",
    maxLength: 9,
    flag: "🇱🇷",
  },
  "+232": {
    name: "Sierra Leone",
    pattern: "+232 ## ######",
    maxLength: 8,
    flag: "🇸🇱",
  },
  "+233": {
    name: "Ghana",
    pattern: "+233 ### ### ###",
    maxLength: 9,
    flag: "🇬🇭",
  },
  "+234": {
    name: "Nigeria",
    pattern: "+234 ### ### ####",
    maxLength: 10,
    flag: "🇳🇬",
  },
  "+235": {
    name: "Chad",
    pattern: "+235 ## ## ## ##",
    maxLength: 8,
    flag: "🇹🇩",
  },
  "+236": {
    name: "Central African Republic",
    pattern: "+236 ## ## ## ##",
    maxLength: 8,
    flag: "🇨🇫",
  },
  "+237": {
    name: "Cameroon",
    pattern: "+237 ### ## ## ##",
    maxLength: 9,
    flag: "🇨🇲",
  },
  "+238": {
    name: "Cape Verde",
    pattern: "+238 ### ## ##",
    maxLength: 7,
    flag: "🇨🇻",
  },
  "+239": {
    name: "São Tomé and Príncipe",
    pattern: "+239 ### ####",
    maxLength: 7,
    flag: "🇸🇹",
  },
  "+240": {
    name: "Equatorial Guinea",
    pattern: "+240 ### ### ###",
    maxLength: 9,
    flag: "🇬🇶",
  },
  "+241": {
    name: "Gabon",
    pattern: "+241 ## ## ## ##",
    maxLength: 8,
    flag: "🇬🇦",
  },
  "+242": {
    name: "Republic of the Congo",
    pattern: "+242 ## ### ####",
    maxLength: 9,
    flag: "🇨🇬",
  },
  "+243": {
    name: "Democratic Republic of the Congo",
    pattern: "+243 ### ### ###",
    maxLength: 9,
    flag: "🇨🇩",
  },
  "+244": {
    name: "Angola",
    pattern: "+244 ### ### ###",
    maxLength: 9,
    flag: "🇦🇴",
  },
  "+245": {
    name: "Guinea-Bissau",
    pattern: "+245 ### ####",
    maxLength: 7,
    flag: "🇬🇼",
  },
  "+246": {
    name: "British Indian Ocean Territory",
    pattern: "+246 ### ####",
    maxLength: 7,
    flag: "🇮🇴",
  },
  "+247": {
    name: "Ascension Island",
    pattern: "+247 ####",
    maxLength: 4,
    flag: "🇦🇨",
  },
  "+248": {
    name: "Seychelles",
    pattern: "+248 # ### ###",
    maxLength: 7,
    flag: "🇸🇨",
  },
  "+249": {
    name: "Sudan",
    pattern: "+249 ### ### ###",
    maxLength: 9,
    flag: "🇸🇩",
  },
  "+250": {
    name: "Rwanda",
    pattern: "+250 ### ### ###",
    maxLength: 9,
    flag: "🇷🇼",
  },
  "+251": {
    name: "Ethiopia",
    pattern: "+251 ### ### ###",
    maxLength: 9,
    flag: "🇪🇹",
  },
  "+252": {
    name: "Somalia",
    pattern: "+252 ## ### ###",
    maxLength: 8,
    flag: "🇸🇴",
  },
  "+253": {
    name: "Djibouti",
    pattern: "+253 ## ## ## ##",
    maxLength: 8,
    flag: "🇩🇯",
  },
  "+254": {
    name: "Kenya",
    pattern: "+254 ### ######",
    maxLength: 9,
    flag: "🇰🇪",
  },
  "+255": {
    name: "Tanzania",
    pattern: "+255 ### ### ###",
    maxLength: 9,
    flag: "🇹🇿",
  },
  "+256": {
    name: "Uganda",
    pattern: "+256 ### ### ###",
    maxLength: 9,
    flag: "🇺🇬",
  },
  "+257": {
    name: "Burundi",
    pattern: "+257 ## ## ## ##",
    maxLength: 8,
    flag: "🇧🇮",
  },
  "+258": {
    name: "Mozambique",
    pattern: "+258 ## ### ####",
    maxLength: 9,
    flag: "🇲🇿",
  },
  "+260": {
    name: "Zambia",
    pattern: "+260 ### ### ###",
    maxLength: 9,
    flag: "🇿🇲",
  },
  "+261": {
    name: "Madagascar",
    pattern: "+261 ## ## ### ##",
    maxLength: 9,
    flag: "🇲🇬",
  },
  "+262": {
    name: "Réunion / Mayotte",
    pattern: "+262 ##### ####",
    maxLength: 9,
    flag: "🇷🇪🇾🇹",
  },
  "+263": {
    name: "Zimbabwe",
    pattern: "+263 ### ##### ##",
    maxLength: 9,
    flag: "🇿🇼",
  },
  "+264": {
    name: "Namibia",
    pattern: "+264 ## ### ####",
    maxLength: 9,
    flag: "🇳🇦",
  },
  "+265": {
    name: "Malawi",
    pattern: "+265 ### ## ## ##",
    maxLength: 9,
    flag: "🇲🇼",
  },
  "+266": {
    name: "Lesotho",
    pattern: "+266 #### ####",
    maxLength: 8,
    flag: "🇱🇸",
  },
  "+267": {
    name: "Botswana",
    pattern: "+267 ## ### ###",
    maxLength: 8,
    flag: "🇧🇼",
  },
  "+268": {
    name: "Swaziland",
    pattern: "+268 ## ## ## ##",
    maxLength: 8,
    flag: "🇸🇿",
  },
  "+269": {
    name: "Comoros",
    pattern: "+269 ### ## ##",
    maxLength: 7,
    flag: "🇰🇲",
  },
  "+290": {
    name: "Saint Helena",
    pattern: "+290 ####",
    maxLength: 4,
    flag: "🇸🇭",
  },
  "+291": {
    name: "Eritrea",
    pattern: "+291 # ### ###",
    maxLength: 7,
    flag: "🇪🇷",
  },
  "+297": { name: "Aruba", pattern: "+297 ### ####", maxLength: 7, flag: "🇦🇼" },
  "+298": {
    name: "Faroe Islands",
    pattern: "+298 ######",
    maxLength: 6,
    flag: "🇫🇴",
  },
  "+299": {
    name: "Greenland",
    pattern: "+299 ## ## ##",
    maxLength: 6,
    flag: "🇬🇱",
  },
  "+350": {
    name: "Gibraltar",
    pattern: "+350 #### ####",
    maxLength: 8,
    flag: "🇬🇮",
  },
  "+351": {
    name: "Portugal",
    pattern: "+351 ### ### ###",
    maxLength: 9,
    flag: "🇵🇹",
  },
  "+352": {
    name: "Luxembourg",
    pattern: "+352 #### ####",
    maxLength: 8,
    flag: "🇱🇺",
  },
  "+353": {
    name: "Ireland",
    pattern: "+353 ## ### ####",
    maxLength: 9,
    flag: "🇮🇪",
  },
  "+354": {
    name: "Iceland",
    pattern: "+354 ### ####",
    maxLength: 7,
    flag: "🇮🇸",
  },
  "+355": {
    name: "Albania",
    pattern: "+355 ## ### ####",
    maxLength: 9,
    flag: "🇦🇱",
  },
  "+356": {
    name: "Malta",
    pattern: "+356 #### ####",
    maxLength: 8,
    flag: "🇲🇹",
  },
  "+357": {
    name: "Cyprus",
    pattern: "+357 ## ######",
    maxLength: 8,
    flag: "🇨🇾",
  },
  "+358": {
    name: "Finland",
    pattern: "+358 ## ### ####",
    maxLength: 9,
    flag: "🇫🇮",
  },
  "+359": {
    name: "Bulgaria",
    pattern: "+359 ### ### ###",
    maxLength: 9,
    flag: "🇧🇬",
  },
  "+370": {
    name: "Lithuania",
    pattern: "+370 ### #####",
    maxLength: 8,
    flag: "🇱🇹",
  },
  "+371": {
    name: "Latvia",
    pattern: "+371 ## ### ###",
    maxLength: 8,
    flag: "🇱🇻",
  },
  "+372": {
    name: "Estonia",
    pattern: "+372 #### ####",
    maxLength: 8,
    flag: "🇪🇪",
  },
  "+373": {
    name: "Moldova",
    pattern: "+373 ### ### ###",
    maxLength: 8,
    flag: "🇲🇩",
  },
  "+374": {
    name: "Armenia",
    pattern: "+374 ## ######",
    maxLength: 8,
    flag: "🇦🇲",
  },
  "+375": {
    name: "Belarus",
    pattern: "+375 ## ### ####",
    maxLength: 9,
    flag: "🇧🇾",
  },
  "+376": { name: "Andorra", pattern: "+376 ######", maxLength: 6, flag: "🇦🇩" },
  "+377": {
    name: "Monaco",
    pattern: "+377 ## ## ## ##",
    maxLength: 8,
    flag: "🇲🇨",
  },
  "+378": {
    name: "San Marino",
    pattern: "+378 #### ######",
    maxLength: 10,
    flag: "🇸🇲",
  },
  "+380": {
    name: "Ukraine",
    pattern: "+380 ## ### ####",
    maxLength: 9,
    flag: "🇺🇦",
  },
  "+381": {
    name: "Serbia",
    pattern: "+381 ## ### ####",
    maxLength: 9,
    flag: "🇷🇸",
  },
  "+382": {
    name: "Montenegro",
    pattern: "+382 ## ### ###",
    maxLength: 8,
    flag: "🇲🇪",
  },
  "+383": {
    name: "Kosovo",
    pattern: "+383 ## ### ###",
    maxLength: 8,
    flag: "🇽🇰",
  },
  "+385": {
    name: "Croatia",
    pattern: "+385 ## ### ####",
    maxLength: 9,
    flag: "🇭🇷",
  },
  "+386": {
    name: "Slovenia",
    pattern: "+386 ## ### ###",
    maxLength: 8,
    flag: "🇸🇮",
  },
  "+387": {
    name: "Bosnia and Herzegovina",
    pattern: "+387 ## ####-###",
    maxLength: 8,
    flag: "🇧🇦",
  },
  "+389": {
    name: "North Macedonia",
    pattern: "+389 ## ### ###",
    maxLength: 8,
    flag: "🇲🇰",
  },
  "+420": {
    name: "Czech Republic",
    pattern: "+420 ### ### ###",
    maxLength: 9,
    flag: "🇨🇿",
  },
  "+421": {
    name: "Slovakia",
    pattern: "+421 ### ### ###",
    maxLength: 9,
    flag: "🇸🇰",
  },
  "+423": {
    name: "Liechtenstein",
    pattern: "+423 ### ####",
    maxLength: 7,
    flag: "🇱🇮",
  },
  "+500": {
    name: "Falkland Islands",
    pattern: "+500 #####",
    maxLength: 5,
    flag: "🇫🇰",
  },
  "+501": {
    name: "Belize",
    pattern: "+501 ###-####",
    maxLength: 7,
    flag: "🇧🇿",
  },
  "+502": {
    name: "Guatemala",
    pattern: "+502 #### ####",
    maxLength: 8,
    flag: "🇬🇹",
  },
  "+503": {
    name: "El Salvador",
    pattern: "+503 #### ####",
    maxLength: 8,
    flag: "🇸🇻",
  },
  "+504": {
    name: "Honduras",
    pattern: "+504 #### ####",
    maxLength: 8,
    flag: "🇭🇳",
  },
  "+505": {
    name: "Nicaragua",
    pattern: "+505 #### ####",
    maxLength: 8,
    flag: "🇳🇮",
  },
  "+506": {
    name: "Costa Rica",
    pattern: "+506 #### ####",
    maxLength: 8,
    flag: "🇨🇷",
  },
  "+507": {
    name: "Panama",
    pattern: "+507 #### ####",
    maxLength: 8,
    flag: "🇵🇦",
  },
  "+508": {
    name: "Saint Pierre and Miquelon",
    pattern: "+508 ## ## ##",
    maxLength: 6,
    flag: "🇵🇲",
  },
  "+509": {
    name: "Haiti",
    pattern: "+509 ## ## ####",
    maxLength: 8,
    flag: "🇭🇹",
  },
  "+590": {
    name: "Guadeloupe",
    pattern: "+590 ### ## ## ##",
    maxLength: 9,
    flag: "🇬🇵",
  },
  "+591": {
    name: "Bolivia",
    pattern: "+591 # ### ####",
    maxLength: 8,
    flag: "🇧🇴",
  },
  "+592": {
    name: "Guyana",
    pattern: "+592 ### ####",
    maxLength: 7,
    flag: "🇬🇾",
  },
  "+593": {
    name: "Ecuador",
    pattern: "+593 ## ### ####",
    maxLength: 9,
    flag: "🇪🇨",
  },
  "+594": {
    name: "French Guiana",
    pattern: "+594 ### ## ## ##",
    maxLength: 9,
    flag: "🇬🇫",
  },
  "+595": {
    name: "Paraguay",
    pattern: "+595 ### ### ###",
    maxLength: 9,
    flag: "🇵🇾",
  },
  "+596": {
    name: "Martinique",
    pattern: "+596 ### ## ## ##",
    maxLength: 9,
    flag: "🇲🇶",
  },
  "+597": {
    name: "Suriname",
    pattern: "+597 ###-####",
    maxLength: 7,
    flag: "🇸🇷",
  },
  "+598": {
    name: "Uruguay",
    pattern: "+598 #### ####",
    maxLength: 8,
    flag: "🇺🇾",
  },
  "+599": {
    name: "Netherlands Antilles",
    pattern: "+599 ### ####",
    maxLength: 7,
    flag: "🇨🇼🇧🇶",
  },
  "+670": {
    name: "East Timor",
    pattern: "+670 ### ####",
    maxLength: 7,
    flag: "🇹🇱",
  },
  "+672": {
    name: "Australian Antarctic Territory",
    pattern: "+672 ### ###",
    maxLength: 6,
    flag: "🇦🇶",
  },
  "+673": {
    name: "Brunei",
    pattern: "+673 ### ####",
    maxLength: 7,
    flag: "🇧🇳",
  },
  "+674": { name: "Nauru", pattern: "+674 ### ####", maxLength: 7, flag: "🇳🇷" },
  "+675": {
    name: "Papua New Guinea",
    pattern: "+675 ### ####",
    maxLength: 7,
    flag: "🇵🇬",
  },
  "+676": { name: "Tonga", pattern: "+676 #####", maxLength: 5, flag: "🇹🇴" },
  "+677": {
    name: "Solomon Islands",
    pattern: "+677 #####",
    maxLength: 5,
    flag: "🇸🇧",
  },
  "+678": { name: "Vanuatu", pattern: "+678 #####", maxLength: 5, flag: "🇻🇺" },
  "+679": { name: "Fiji", pattern: "+679 ### ####", maxLength: 7, flag: "🇫🇯" },
  "+680": { name: "Palau", pattern: "+680 ### ####", maxLength: 7, flag: "🇵🇼" },
  "+681": {
    name: "Wallis and Futuna",
    pattern: "+681 ## ## ##",
    maxLength: 6,
    flag: "🇼🇫",
  },
  "+682": {
    name: "Cook Islands",
    pattern: "+682 ## ###",
    maxLength: 5,
    flag: "🇨🇰",
  },
  "+683": { name: "Niue", pattern: "+683 ####", maxLength: 4, flag: "🇳🇺" },
  "+684": {
    name: "American Samoa",
    pattern: "+684 ### ####",
    maxLength: 7,
    flag: "🇦🇸",
  },
  "+685": { name: "Samoa", pattern: "+685 ## ####", maxLength: 6, flag: "🇼🇸" },
  "+686": {
    name: "Kiribati",
    pattern: "+686 ## ###",
    maxLength: 5,
    flag: "🇰🇮",
  },
  "+687": {
    name: "New Caledonia",
    pattern: "+687 ## ## ##",
    maxLength: 6,
    flag: "🇳🇨",
  },
  "+688": { name: "Tuvalu", pattern: "+688 #####", maxLength: 5, flag: "🇹🇻" },
  "+689": {
    name: "French Polynesia",
    pattern: "+689 ## ## ## ##",
    maxLength: 8,
    flag: "🇵🇫",
  },
  "+690": { name: "Tokelau", pattern: "+690 ####", maxLength: 4, flag: "🇹🇰" },
  "+691": {
    name: "Micronesia",
    pattern: "+691 ### ####",
    maxLength: 7,
    flag: "🇫🇲",
  },
  "+692": {
    name: "Marshall Islands",
    pattern: "+692 ### ####",
    maxLength: 7,
    flag: "🇲🇭",
  },
  "+850": {
    name: "North Korea",
    pattern: "+850 ### ### ####",
    maxLength: 10,
    flag: "🇰🇵",
  },
  "+852": {
    name: "Hong Kong",
    pattern: "+852 #### ####",
    maxLength: 8,
    flag: "🇭🇰",
  },
  "+853": {
    name: "Macau",
    pattern: "+853 #### ####",
    maxLength: 8,
    flag: "🇲🇴",
  },
  "+855": {
    name: "Cambodia",
    pattern: "+855 ## ### ###",
    maxLength: 8,
    flag: "🇰🇭",
  },
  "+856": {
    name: "Laos",
    pattern: "+856 ## ### ###",
    maxLength: 8,
    flag: "🇱🇦",
  },
  "+880": {
    name: "Bangladesh",
    pattern: "+880 #### ######",
    maxLength: 10,
    flag: "🇧🇩",
  },
  "+886": {
    name: "Taiwan",
    pattern: "+886 ### ### ###",
    maxLength: 9,
    flag: "🇹🇼",
  },
  "+960": {
    name: "Maldives",
    pattern: "+960 ###-####",
    maxLength: 7,
    flag: "🇲🇻",
  },
  "+961": {
    name: "Lebanon",
    pattern: "+961 ## ### ###",
    maxLength: 8,
    flag: "🇱🇧",
  },
  "+962": {
    name: "Jordan",
    pattern: "+962 # #### ####",
    maxLength: 9,
    flag: "🇯🇴",
  },
  "+963": {
    name: "Syria",
    pattern: "+963 ### ### ###",
    maxLength: 9,
    flag: "🇸🇾",
  },
  "+964": {
    name: "Iraq",
    pattern: "+964 ### ### ####",
    maxLength: 10,
    flag: "🇮🇶",
  },
  "+965": {
    name: "Kuwait",
    pattern: "+965 #### ####",
    maxLength: 8,
    flag: "🇰🇼",
  },
  "+966": {
    name: "Saudi Arabia",
    pattern: "+966 ## ### ####",
    maxLength: 9,
    flag: "🇸🇦",
  },
  "+967": {
    name: "Yemen",
    pattern: "+967 ### ### ###",
    maxLength: 9,
    flag: "🇾🇪",
  },
  "+968": { name: "Oman", pattern: "+968 #### ####", maxLength: 8, flag: "🇴🇲" },
  "+970": {
    name: "Palestine",
    pattern: "+970 ## ### ####",
    maxLength: 9,
    flag: "🇵🇸",
  },
  "+971": {
    name: "United Arab Emirates",
    pattern: "+971 ## ### ####",
    maxLength: 9,
    flag: "🇦🇪",
  },
  "+972": {
    name: "Israel",
    pattern: "+972 ##-###-####",
    maxLength: 9,
    flag: "🇮🇱",
  },
  "+973": {
    name: "Bahrain",
    pattern: "+973 #### ####",
    maxLength: 8,
    flag: "🇧🇭",
  },
  "+974": {
    name: "Qatar",
    pattern: "+974 #### ####",
    maxLength: 8,
    flag: "🇶🇦",
  },
  "+975": {
    name: "Bhutan",
    pattern: "+975 ## ### ###",
    maxLength: 8,
    flag: "🇧🇹",
  },
  "+976": {
    name: "Mongolia",
    pattern: "+976 #### ####",
    maxLength: 8,
    flag: "🇲🇳",
  },
  "+977": {
    name: "Nepal",
    pattern: "+977 ###-### ####",
    maxLength: 10,
    flag: "🇳🇵",
  },
  "+992": {
    name: "Tajikistan",
    pattern: "+992 ### ### ###",
    maxLength: 9,
    flag: "🇹🇯",
  },
  "+993": {
    name: "Turkmenistan",
    pattern: "+993 ## ######",
    maxLength: 8,
    flag: "🇹🇲",
  },
  "+994": {
    name: "Azerbaijan",
    pattern: "+994 ## ### ## ##",
    maxLength: 9,
    flag: "🇦🇿",
  },
  "+995": {
    name: "Georgia",
    pattern: "+995 ### ### ###",
    maxLength: 9,
    flag: "🇬🇪",
  },
  "+996": {
    name: "Kyrgyzstan",
    pattern: "+996 ### ### ###",
    maxLength: 9,
    flag: "🇰🇬",
  },
  "+998": {
    name: "Uzbekistan",
    pattern: "+998 ## ### ## ##",
    maxLength: 9,
    flag: "🇺🇿",
  },
};

export const fetchLocation = async (lat: number, lng: number) => {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
  );
  const data = await response.json();
  return data;
};
